import api_call_v2 from "utils/API_CALL/api_call_v2";
import PROXY_CONFIG from "../../Config/ProxyConfig";
import { decrypt } from "utils/CRYPTO/secret";

const GetDataAgences = async (properties) => {
  let region = properties.region;
  let province = properties.province;
  let commune = properties.commune;
  let quartier = properties.quartier;

  if (!properties.prix_appartement && !properties.prix_villa) {
    quartier = null;
    commune = null;
  }
  return new Promise((resolve, reject) => {
    if (!quartier && !commune) {
      reject([]);
    } else {
      
        api_call_v2(
          undefined,
          "post",
          "annuaire/recherche",
          {
            sort_by: "annonces",
            geometry_label: commune ? "commune" : province ? "province" : region ? "region" : "region",
            geometry_value: commune ? commune : province ? province : region ? region : region,
            type: [],
            limit: 5,
            page: 0,
          }
        )

        .then((res) => {
          resolve(decrypt(res.data));
        })
        .catch((err) => {

          reject(err);
        });
    }
  });
};

export default GetDataAgences;
